export const no = {
  app: {
    name: 'Sine',
    tagline: 'Hva kan jeg hjelpe deg med?',
    placeholder: 'Send en melding til Sine...',
    newChat: 'Ny samtale',
    newTask: 'Ny oppgave',
    search: 'Søk',
    library: 'Bibliotek',
    projects: 'Prosjekter',
    newProject: 'Nytt prosjekt',
    allChats: 'Alle samtaler',
    allTasks: 'Alle oppgaver',
    agents: 'Agenter',
    settings: 'Innstillinger',
    account: 'Konto',
    usage: 'Bruk',
    billing: 'Fakturering',
    getHelp: 'Få hjelp',
    collaborate: 'Samarbeid',
    share: 'Del',
    calendar: 'Kalender',
    notifications: 'Varsler',
    closeSidebar: 'Lukk sidebar',
    display: 'Visning',
    conversation: 'Samtale',
    help: 'Hjelp',
  },
  chat: {
    send: 'Send',
    stop: 'Stopp',
    regenerate: 'Generer på nytt',
    edit: 'Rediger',
    copy: 'Kopier',
    copied: 'Kopiert!',
    thinking: 'Tenker...',
    model: {
      'sine-lite': 'Sine Lite',
      'sine-pro': 'Sine Pro',
      'sine-max': 'Sine Max',
      'sine-1': 'Sine Lite',
    },
    welcome: {
      title: 'Hva kan jeg gjøre for deg?',
      subtitle: 'Norsk AI-assistent for chat og oppgaver',
    },
    suggestions: [
      'Lag en presentasjon',
      'Bygg en nettside',
      'Analyser data',
      'Skriv en rapport',
    ],
    uploadFile: 'Last opp fil',
    voiceInput: 'Taleinndata',
    writeCode: 'Skriv kode',
    writeCodeFor: 'Skriv kode for',
    close: 'Lukk',
    activateAgentTask: 'Aktiver agentisk oppgave',
    whatDoesThisSkillDo: 'Hva gjør denne skillen?',
    continue: 'Fortsett',
    whatWouldYouLikeToBuild: 'Hva vil du bygge?',
    whatShouldIWrite: 'Hva skal jeg skrive?',
    whatShouldAgentDo: 'Hva skal agenten gjøre?',
    howCanIHelpYou: 'Hvordan kan jeg hjelpe deg?',
    describeApp: 'Beskriv en app, trigger, grensesnitt eller automatisering du vil lage',
    writingAgentHelp: 'Skriveagenten hjelper deg med dokumenter, rapporter og bøker',
  },
  settings: {
    title: 'Innstillinger',
    general: 'Generelt',
    language: 'Språk',
    appearance: 'Utseende',
    dark: 'Mørk',
    light: 'Lys',
    followSystem: 'Følg system',
    communicationPreferences: 'Kommunikasjonspreferanser',
    receiveUpdates: 'Motta produktoppdateringer',
    receiveUpdatesDesc: 'Få tidlig tilgang til nye funksjoner og suksesshistorier.',
    emailOnTask: 'E-post når oppgave starter',
    emailOnTaskDesc: 'Vi sender deg en e-post når din oppgave begynner å kjøre.',
    scheduledTasks: 'Planlagte oppgaver',
    emailSine: 'E-post Sine',
    dataControl: 'Datakontroll',
    personalization: 'Personalisering',
    skills: 'Ferdigheter',
    connections: 'Tilkoblinger',
    integrations: 'Integrasjoner',
    agentHistory: 'Agent-historikk',
    pushNotificationsCalendar: 'Push-varsler for kalenderoppgaver',
    pushNotificationsCalendarDesc: 'Motta varsler i appen når en agentisk oppgave er i ferd med å kjøre eller er fullført.',
    autoApproveCalendar: 'Automatisk godkjenning av kalenderoppgaver',
    autoApproveCalendarDesc: 'Når aktivert kan Sine automatisk legge til repeterende oppgaver i kalenderen uten manuell bekreftelse. Anbefales kun for erfarne brukere.',
    saved: 'Lagret ✓',
    save: 'Lagre',
    saving: 'Lagrer...',
    error: 'Feil',
    notAvailable: 'Ikke tilgjengelig',
    deleteScheduledTask: 'Slett oppgave',
    // Account
    profileInfo: 'Profilinformasjon',
    emailAddress: 'E-postadresse',
    password: 'Passord',
    changePasswordDesc: 'Oppdater passordet ditt for å holde kontoen sikker.',
    session: 'Økt',
    logOut: 'Logg ut',
    logOutDesc: 'Logg ut av Sine på denne enheten.',
    dangerZone: 'Faresone',
    deleteAccount: 'Slett konto',
    deleteAccountDesc: 'Sletter kontoen din og alle tilhørende data permanent. Denne handlingen kan ikke angres.',
    delete: 'Slett',
    change: 'Endre',
    // Personalization
    aboutYou: 'Om deg',
    name: 'Navn',
    nameDesc: 'Hva skal Sine kalle deg?',
    yourName: 'Ditt navn',
    customInstructions: 'Egendefinerte instruksjoner',
    customInstructionsDesc: 'Fortell Sine om deg selv, hva du jobber med og hva du er interessert i. Dette hjelper Sine å gi deg mer relevante og personlige svar.',
    customInstructionsPlaceholder: 'Eks: Jeg jobber med tech og AI. Jeg liker korte, direkte svar...',
    // Usage
    transactionHistory: 'Transaksjonshistorikk',
    noTransactions: 'Ingen transaksjoner ennå.',
    usedThisMonth: 'Brukt denne måneden',
    availableCredits: 'Tilgjengelige kreditter',
    approachingLimit: 'Du nærmer deg grensen din.',
    // Chat
    addAttachment: 'Legg til vedlegg',
    terminal: 'Terminal',
    switchToAgent: 'Bruk verktøy og filer',
  },
  layout: {
    back: 'Tilbake',
    rename: 'Gi samtalen nytt navn',
    renamePrompt: 'Gi samtalen et nytt navn:',
    taskDetails: 'Oppgavedetaljer',
    rateTask: 'Vurder denne oppgaven',
    cancel: 'Avbryt',
    delete: 'Slett',
    moveToProject: 'Flytt til prosjekt',
    logoutConfirm: 'Er du sikker på at du vil logge ut?',
    logoutAs: 'Logg ut av Sine som {{email}}?',
    chatMode: 'Raskt svar og samtale',
    agentMode: 'Dyp arbeidsflyt med verktøy',
    powerfulForComplex: 'Kraftig for komplekse oppgaver',
    connectorsSelected: '{{count}} connector{{s}} valgt',
    connectorsOptional: 'Connectors (valgfritt)',
    enterName: 'Skriv inn navn',
    whatIsCredits: 'Hva er kreditter?',
    getFeedback: 'Få hjelp',
    taskDetailsTitle: 'Oppgavedetaljer',
    newProject: 'Nytt prosjekt',
  },
  connectors: {
    gmailDesc: 'La Sine lese og sende e-post på dine vegne via Gmail.',
    email: 'E-post',
    outlookDesc: 'Koble til Outlook for å lese og sende e-post via Microsoft-kontoen din.',
    googleCalendarDesc: 'La Sine se og opprette kalenderoppføringer i Google Calendar.',
    calendar: 'Kalender',
    slackDesc: 'Koble til Slack for å sende meldinger og varsler til kanalene dine.',
    vercelDesc: 'La Sine deploye og administrere Vercel-prosjekter.',
    cloudflareDesc: 'Koble til Cloudflare for DNS-administrasjon og sikkerhetsinnstillinger.',
    projectManagement: 'Prosjektstyring',
    mondayDesc: 'Koble til Monday.com for oppgavestyring og teamprosjekter.',
    asanaDesc: 'La Sine opprette og administrere oppgaver i Asana.',
    airtableDesc: 'Koble til Airtable for å lese og skrive til baser og tabeller.',
    metaDesc: 'Analyser og administrer Meta-annonsekampanjer med Sine.',
    instagramDesc: 'Administrer innlegg og analyser engasjement på Instagram.',
    zapierDesc: 'Koble Sine til tusenvis av apper via Zapier-automatisering.',
    encryptedNote: 'Disse lagres kryptert og sendes aldri til klienten',
    githubAuthFailed: 'GitHub-tilkobling feilet:',
    noAuthUrl: 'Ingen auth_url fra backend',
    gmailAuthError: 'Gmail auth-url feil:',
    noGithubAuthUrl: 'Ingen auth_url fra GitHub backend:',
    githubNotConfigured: 'Kunne ikke starte GitHub-autentisering. Sjekk at GitHub App er konfigurert i Admin → Connectors.',
    githubAuthError: 'GitHub auth-url feil:',
    githubConnectError: 'Feil ved tilkobling til GitHub. Prøv igjen.',
  },
  library: {
    noPreview: 'Ingen forhåndsvisning tilgjengelig ennå.',
    newConversation: 'Ny samtale',
    moreOptions: 'Flere alternativer',
    close: 'Lukk',
    noContent: '# Ingen innhold\n\nDette dokumentet har ikke lagret innhold ennå.',
    searchFiles: 'Søk i filer',
    locateInConversations: 'Lokaliser i samtaler',
    sendToSine: 'Send til Sine',
    share: 'Del',
    download: 'Last ned',
    asMarkdown: 'Som Markdown',
    asPdf: 'Som PDF',
    asDocx: 'Som DOCX',
    openOriginal: 'Åpne original',
    compressedFileDesc: 'Komprimert fil med innhold og vedlegg.',
    favorite: 'Favoritt',
    removeFromFavorites: 'Fjern fra favoritter',
    addToFavorites: 'Legg til som favoritt',
    noFilesFound: 'Ingen filer funnet',
    dropFilesHere: 'Slipp filer her',
    allFiles: 'Alle filer',
    images: 'Bilder',
    documents: 'Dokumenter',
    code: 'Kode',
    other: 'Annet',
    sortBy: 'Sorter etter',
    date: 'Dato',
    name: 'Navn',
    size: 'Størrelse',
    filterBy: 'Filtrer etter',
    clearFilter: 'Fjern filter',
    deleteFile: 'Slett fil',
    deleteFileConfirm: 'Slett denne filen?',
    fileDeleted: 'Fil slettet',
    uploadFile: 'Last opp fil',
    uploading: 'Laster opp...',
    uploadError: 'Opplasting mislyktes',
    copyLink: 'Kopier lenke',
    linkCopied: 'Lenke kopiert!',
    preview: 'Forhåndsvisning',
    noMemories: 'Ingen minner ennå',
    addMemory: 'Legg til minne',
    memoryTitle: 'Minnetittel',
    memoryContent: 'Minneinnhold',
    saveMemory: 'Lagre minne',
    deleteMemory: 'Slett minne',
    deleteMemoryConfirm: 'Slett dette minnet?',
    memoryGraph: 'Kunnskapsgraf',
    memoryList: 'Minneliste',
    memoryNote: 'Minnenotat',
    newMemory: 'Nytt minne',
    searchMemories: 'Søk i minner...',
    noMemoriesFound: 'Ingen minner funnet',
    memoryDeleted: 'Minne slettet',
    memorySaved: 'Minne lagret',
    collapseGraph: 'Skjul graf',
    expandGraph: 'Vis graf',
  },
  agents: {
    researchDesc: 'Søker og analyserer informasjon fra nettet, kompilerer rapporter og oppsummerer funn.',
    researchReady: 'Jeg er klar til å søke og analysere informasjon fra nettet for deg. Hva vil du at jeg skal undersøke?',
    codeDesc: 'Skriver, debugger og refaktorerer kode på tvers av alle programmeringsspråk.',
    codeReady: 'Jeg er klar til å hjelpe deg med kode. Beskriv hva du vil bygge, fikse eller forbedre.',
    dataAnalyst: 'data-analytiker',
    dataDesc: 'Analyserer datasett, lager visualiseringer og gir innsikt fra strukturerte data.',
    analysis: 'Analyse',
    dataReady: 'Jeg er klar til å analysere data for deg. Del et datasett eller beskriv hva du vil analysere.',
    writerDesc: 'Skriver og redigerer dokumenter, rapporter, presentasjoner og teknisk innhold.',
    writerReady: 'Jeg er klar til å skrive dokumenter for deg. Hva trenger du hjelp til å skrive?',
    automationTitle: 'Oppgaveautomatisering',
    automationDesc: 'Automatiserer repeterende oppgaver, planlegger og utfører flertrinnsprosesser.',
    automationReady: 'Jeg er klar til å automatisere oppgaver for deg. Beskriv hva du vil automatisere.',
    failed: 'Feilet',
    loadHistoryError: 'Kunne ikke laste historikk. Prøv igjen.',
    done: 'Ferdig',
    waitingForInfo: 'Venter på info',
    taskComplete: 'Oppgave fullført!',
    connectionError: 'Tilkoblingsfeil til agent-backend',
    reconnected: 'Tilkoblet igjen — fortsetter',
    continuing: 'Fortsetter',
  },
  admin: {
    users: 'Brukere',
    analytics: 'Analyse',
    notifications: 'Varsler',
    helpCenter: 'Hjelpesenter',
    settings: 'Innstillinger',
    couldNotLoadTools: 'Kunne ikke laste verktøy',
    toolUpdateError: 'Feil ved oppdatering av verktøy',
    allToolsReset: 'Alle verktøy tilbakestilt til standard',
    resetError: 'Feil ved tilbakestilling',
    saved: 'Lagret!',
    error: 'Feil:',
    networkError: 'Nettverksfeil',
    deleteArticleConfirm: 'Slett denne artikkelen?',
    deletePostConfirm: 'Slett dette innlegget?',
    removeAdminConfirm: 'Fjern admin-rettigheter fra denne brukeren?',
    emailRequired: 'E-post er påkrevd',
    userAdded: 'Bruker lagt til!',
    savingDraft: 'Lagrer...',
    saveDraft: 'Lagre utkast',
    pageViews: 'Sidevisninger (7 dager)',
    bounceRate: 'Avvisningsrate',
    searchEmail: 'Søk på e-post...',
    allUsers: 'Brukere',
    viewEditUser: 'Vis / rediger bruker',
    shortDescription: 'Kort beskrivelse (vises i listevisning)',
    writeContent: 'Skriv innhold her...',
    delete: 'Slett',
    sentNotifications: 'Sendte varsler',
    dataAndVisualization: 'Data og visualisering',
    editArticle: 'Rediger artikkel',
    newArticle: 'Ny artikkel',
    exampleQuestion: 'F.eks. Hva er kreditter og hvordan brukes de?',
    writeAnswerMarkdown: 'Skriv svar i Markdown-format...',
    exampleSlug: 'f.eks. kreditter-forklart (auto-generert hvis tomt)',
    deleteAllNotificationsConfirm: 'Slett alle varsler?',
    emailPlaceholder: 'bruker@eksempel.no',
    save: 'Lagre',
    saving: 'Lagrer...',
  },
  help: {
    searchPlaceholder: 'Søk i hjelpeartikler...',
  },
  calendar: {
    title: 'Kalender',
    newTask: 'Ny oppgave',
    editTask: 'Rediger oppgave',
    deleteTask: 'Slett oppgave',
    deleteTaskConfirm: 'Slett denne oppgaven?',
    taskDeleted: 'Oppgave slettet',
    taskSaved: 'Oppgave lagret',
    today: 'I dag',
    newEvent: 'Ny hendelse',
    week: 'Uke',
    month: 'Måned',
    day: 'Dag',
    noTasks: 'Ingen planlagte oppgaver',
    schedule: 'Planlegg',
    repeat: 'Gjenta',
    daily: 'Daglig',
    weekly: 'Ukentlig',
    monthly: 'Månedlig',
    never: 'Aldri',
    dueDate: 'Frist',
    priority: 'Prioritet',
    high: 'Høy',
    medium: 'Middels',
    low: 'Lav',
    status: 'Status',
    pending: 'Venter',
    inProgress: 'Pågår',
    completed: 'Fullført',
    cancelled: 'Avbrutt',
  },
  errors: {
    apiKeyMissing: 'API-nøkkel mangler. Sjekk Sine-konfigurasjonen i .env',
    networkError: 'Nettverksfeil. Prøv igjen.',
    unknown: 'En ukjent feil oppstod.',
  },
}
export type Translations = typeof no
